<template lang="pug">
  MDashboardWidget( title="Finished Status Processing Report" )

    div( class="input-group search-bar" )
      div( class="input-group-prepend" )
        span( class="input-group-addon" )
          select( class="form-control" type="select"  v-model="finishTime")
            option( value="60000" ) 1 minute
            option( value="300000" ) 5 minutes
            option( value="1800000" ) 30 minutes
            option( value="3600000" ) 1 Hour

    div( class="row" )
      div( class="col-12 text-right" )
        p Page {{ page }} of {{ lastPageNum }}
        span Per page:&nbsp;
        select( v-model="pageSize" )
          option( value="10" ) 10
          option( value="25" ) 25
          option( value="50" ) 50
          option( value="100" ) 100
        | &nbsp;
        div( class="btn-group" )
          button( class="btn btn-white" v-bind:disabled="page === 1" v-on:click="() => page -= 1" ) Prev page
          button( class="btn btn-white" v-bind:disabled="page === lastPageNum" v-on:click="() => page += 1" ) Next page

    table( v-if="! $apollo.loading" class="table-hover no-margins" )
      thead
        th Finish time
        th Start time
        th Audit processing time
        th finished Y/N
        th Batch ID
        th Name / Description
        th user FN LN Company
        th Audit Report
        th Actions
      tbody
        tr(v-for="audit in audits.items" )
          td {{ dateFormat(audit.auditedAt + audit.auditTime, 'dd/mm/yy HH:MM') }}
          
          td {{ dateFormat(audit.auditedAt, 'dd/mm/yy HH:MM') }}
          td {{ Math.floor(audit.auditTime / 1000) }} seconds

          td
            span( v-if="audit.status === 'DONE'" class="label label-primary" ) Y 
            span(v-else class="label label-danger") N

          td {{ audit.batch.id.substr(-4) }}

          td( class="audit-name" )
            | {{ audit.batch.name }}
            br
            em {{ audit.batch.description }}

          td
            em( v-if="audit.batch.owner" )
              span {{ audit.batch.owner.name }}
              br
              span( v-if="audit.batch.owner.company" ) {{ audit.batch.owner.company.name }}

          td 
            router-link( v-bind:to="`/reporting/batches/${audit.batch.id}/audits/${audit.id}`" target="_blank") {{ `/reporting/batches/${audit.batch.id}/audits/${audit.id}/output-report` }}
          
          td               
            router-link( class="btn btn-details btn-outline btn-info" v-bind:to="`/reporting/batches/${audit.batch.id}/audits/${audit.id}`" target="_blank") Open Audit Technical Page
        
</template>
<script>
import Vue from 'vue'
import * as dateFormat from 'dateformat'
import gql from 'graphql-tag'
export default Vue.extend({
  data () {
    return {
      page: 1,
      pageSize: 10,
      finishTime: 60000,
    }
  },
 
  apollo: {

    audits: {
      query: gql`query AuditPaginated ($page: Float!, $pageSize: Float!, $finishTime: DateTime!) {
        auditMany(
          filter:{
            status: DONE
            auditedAt: {
              greaterThanEqualTo: $finishTime
            }
          }
          page: $page
          perPage: $pageSize
          sort: {
            auditedAt: DESC
          }
        ) {
          count
          items{
            batch {
              id
              name
              description
              owner{
                name
                company{
                  name
                }
              }
            }
            assignedTo{
              name
              email
              }
            id
            auditedAt
            auditTime
            status
          }
        }
      }`,
      variables() {
        return {
          page: Number(this.page),
          pageSize: Number(this.pageSize),
          finishTime: new Date(Date.now() - Number(this.finishTime))
        }
      },
      update: data => data.auditMany,
    }
  },

  computed: {
    lastPageNum() {
      return this.audits ? Math.ceil(this.audits.count / this.pageSize) : '...'
    }
  },
  methods: {
    dateFormat,
      }
})
</script>